/** People-free photography generated from the standing brief in docs/IMAGE-SYSTEM.md. */
export const aboutHeroImage: { image: string; alt: string } = {
  image:
    'https://cdn.magicpatterns.com/patterns/generated-images/fcfda876-7d3b-404a-bbef-638c8a342faf.jpg',
  alt: 'A quiet daylight studio corner with a pale oak desk, one black chair and a restrained shelf of books',
}

export const aboutStoryImage: { image: string; alt: string } = {
  image:
    'https://cdn.magicpatterns.com/patterns/generated-images/ff50dda1-2b60-4696-9824-885f3a8f344c.jpg',
  alt: 'A single black desk lamp casting warm light across an open blank notebook on a bare desk',
}

export const operatingImages: { image: string; alt: string }[] = [
  {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/e4eadf67-ecaf-4d00-be1e-a7c13a022c90.jpg',
    alt: 'A minimal paper calendar page with one review window marked by a black circular token',
  },
  {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/bdd11ec3-de54-4082-bb96-e5be85e5b338.jpg',
    alt: 'A concise project note represented by soft grey bars on heavy bone paper beside a black pencil',
  },
  {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/ec8508cb-514d-4907-91b0-f9c914a96c5f.jpg',
    alt: 'A printed project schedule of thin rules and timing blocks clipped neatly to a plain board',
  },
]

export const capabilitiesImage: { image: string; alt: string } = {
  image:
    'https://cdn.magicpatterns.com/patterns/generated-images/ee2a2b75-93ca-44e8-bd15-09c385ce2592.jpg',
  alt: 'A closed black laptop, muted colour guide, metal ruler and graphite pencil laid flat on warm off-white paper',
}
